(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-recipe"] && !Shopify.designMode) return;
  try {
    
    function equalizeSlideHeights() {
        const slides = document.querySelectorAll('.swiper-slide .recipe-slide');
        let maxHeight = 0;

        slides.forEach((slide) => {
            slide.style.height = 'auto';
        });

        slides.forEach((slide) => {
            const height = slide.offsetHeight;
            if (height > maxHeight) maxHeight = height;
        });

        slides.forEach((slide) => {
            slide.style.height = maxHeight + 'px';
        });
    }

    window.addEventListener('load', equalizeSlideHeights);
    window.addEventListener('resize', equalizeSlideHeights);

    // Initialize Swiper
    var swiper = new Swiper('.swiper-container', {
        slidesPerView: 1.3,
        spaceBetween: 10,
        centeredSlides: true,
        loop: false,
        centeredSlides: false,
        autoplay:
            window.innerWidth >= 768
                ? {
                      delay: 3000,
                      disableOnInteraction: false,
                  }
                : false,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },
    });

    // Quantity selector state
    let modalQty = 1;

    function updateModalQtyDisplay() {
        document.getElementById('modal-qty').textContent = modalQty;
    }

    document.getElementById('modal-plus').addEventListener('click', () => {
        modalQty++;
        updateModalQtyDisplay();
    });

    document.getElementById('modal-minus').addEventListener('click', () => {
        if (modalQty > 1) {
            modalQty--;
            updateModalQtyDisplay();
        }
    });

    // Open Modal on recipe click
    document.querySelectorAll('.recipe-slide').forEach(function (slide) {
        slide.addEventListener('click', function () {
            let image = slide.getAttribute('data-image');
            let title = slide.getAttribute('data-title');
            let description = slide.getAttribute('data-description');
            let length = slide.getAttribute('data-length');
            let product = slide.getAttribute('data-product');
            const variantId = slide.getAttribute(
                'data-related-product-variant-id'
            );

            // Reset quantity
            modalQty = 1;

            document.getElementById('recipe-modal-image').src = image;
            document.getElementById('recipe-modal-title').textContent = title;
            document.getElementById('recipe-modal-description').textContent =
                description;

            document.getElementById(
                'recipe-modal-ingredients-title'
            ).textContent = slide.getAttribute('data-ingredients-title');
            document.getElementById('recipe-modal-ingredients').innerHTML =
                slide.getAttribute('data-ingredients');
            document.getElementById('recipe-modal-steps-title').textContent =
                slide.getAttribute('data-steps-title');
            document.getElementById('recipe-modal-steps').innerHTML =
                slide.getAttribute('data-steps');
            document.getElementById(
                'recipe-modal-nutrition-title'
            ).textContent = slide.getAttribute('data-nutrition-title');
            document.getElementById('recipe-modal-nutrition').innerHTML =
                slide.getAttribute('data-nutrition');

            const imageUrl = slide.getAttribute('data-related-product-image');
            const imageHTML = `<img src="${imageUrl}" class="related-product-image">`;
            document.getElementById('recipe-modal-product-image').innerHTML =
                imageHTML;

            document.getElementById('recipe-modal-button').innerText =
                slide.getAttribute('data-atc-button-label');
            document.getElementById(
                'recipe-modal-button'
            ).style.backgroundColor = slide.getAttribute(
                'data-atc-button-color'
            );
            document.getElementById('recipe-modal-button').style.color =
                slide.getAttribute('data-atc-button-text-color');

            document
                .getElementById('modal-plus')
                .setAttribute('data-variant-id', variantId);
            document
                .getElementById('modal-minus')
                .setAttribute('data-variant-id', variantId);

            document.getElementById('recipe-modal-button').onclick =
                function () {
                    if (variantId && modalQty > 0) {
                        const spinner = document.createElement('span');
                        spinner.classList.add('spinner');
                        this.appendChild(spinner);
                        addToCart(variantId, modalQty);
                    } else {
                        console.error('Variant ID not provided.');
                    }
                };

            document.getElementById('recipe-modal-length').textContent = length;
            document.getElementById('recipe-modal').classList.add('open');
            document.body.style.overflow = 'hidden';
        });
    });

    // Close Modal
    document.querySelector('.close').addEventListener('click', function () {
        document.getElementById('recipe-modal').classList.remove('open');
        document.body.style.overflow = '';
    });

    function addToCart(variantId, quantity = 1) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Added to cart:', data);
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: {
                            source_section: 'recipe_section',
                        },
                    }),
                });
            })
            .then((response) => response.json())
            .then((cart) => {
                console.log('Cart attribute set:', cart);
                window.location.href = '/cart';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
